<template>
  <div>
    <base-table :data="publicities.data" thead-classes="text-primary">
      <template slot="columns">
        <th>Imagem</th>
        <th class="text-center">ID</th>
        <th>Nome</th>
        <th class="text-right">Status</th>
        <th class="text-right">Ações</th>
      </template>

      <template slot-scope="{ row }">
        <td style="width: 110px;">
          <img :src="row.image_url" />
        </td>

        <td class="text-center">{{ row.id }}</td>
        <td>{{ row.name }}</td>

        <td class="text-right">
          <span v-if="row.is_active === 1" style="color: green;">
            Ativo
          </span>

          <span v-if="row.is_active === 0" style="color: red;">
            Inativo
          </span>
        </td>

        <td class="text-right">
          <el-tooltip
            content="Editar"
            effect="light"
            :open-delay="300"
            placement="top"
          >
            <router-link :to="`publicities/new/${row.id}`">
              <base-button type="info" icon size="sm" class="btn-link">
                <i class="tim-icons icon-pencil"></i>
              </base-button>
            </router-link>
          </el-tooltip>

          <el-tooltip
            content="Remover"
            effect="light"
            :open-delay="300"
            placement="top"
          >
            <base-button
              type="danger"
              icon
              size="sm"
              class="btn-link"
              @click="removePublicity(row)"
            >
              <i class="tim-icons icon-trash-simple"></i>
            </base-button>
          </el-tooltip>
        </td>
      </template>
    </base-table>
    <div class="pagination-div">
      <base-pagination
        type="warning"
        :page-count="publicities.last_page"
        v-model="current_page"
        @input="handleChangePage"
      />
    </div>
  </div>
</template>
<script>
import { BaseTable, BasePagination } from '@/components'

export default {
  name: 'PublicityTable',
  async created () {
    await this.makePagination(this.current_page)
  },
  data: () => ({
    publicities: false,
    current_page: 1
  }),
  methods: {
    async removePublicity (publicity) {
      await this.$http.delete(`/publicities/${publicity.id}`)

      const publicityIndex = this.publicities.data.findIndex(
        d => d.id === publicity.id
      )
      this.publicities.data.splice(publicityIndex, 1)
    },
    handleChangePage (next_page) {
      this.makePagination(next_page)
    },
    async makePagination (page) {
      const {
        data: { data }
      } = await this.$http.get(`/publicities?page=${page}`)

      this.publicities = data
      this.current_page = data.current_page
    }
  },
  components: { BaseTable, BasePagination }
}
</script>

<style scoped lang="scss">
.pagination-div {
  display: flex;
  justify-content: flex-end;
}
</style>
